import { render } from "./ProgramType.vue?vue&type=template&id=f9e7482a&ts=true"
import script from "./ProgramType.vue?vue&type=script&lang=ts"
export * from "./ProgramType.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__